import { render } from "./LocationConfirmation.vue?vue&type=template&id=618170e1&scoped=true"
import script from "./LocationConfirmation.vue?vue&type=script&lang=js"
export * from "./LocationConfirmation.vue?vue&type=script&lang=js"

import "./LocationConfirmation.vue?vue&type=style&index=0&id=618170e1&lang=scss&scoped=true"

import exportComponent from "/home/forge/demo-logistic.hoornbloommasters.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618170e1"]])

export default __exports__